import React from "react";

export const ReservationPopoverContext = React.createContext({});
